<form [formGroup]="formGroup">
  <ng-container [ngTemplateOutlet]="attemptCount === 3 ? validationFailedDisplay : privatperson ? privatpersonDisplay : firmaDisplay"></ng-container>
  <ng-template #privatpersonDisplay>
    <div mat-dialog-content>
      <p>Bevor Sie aus Ihrem Angebot einen Antrag erstellen können, bestätigen Sie bitte das im Angebot eingetragene Geburtsdatum.</p>
      <div class="input">
        <app-label [control]="geburtsdatum" class="input-date-picker__label" for="geburtsdatum">Geburtsdatum:</app-label>
        <mat-form-field>
          <input matInput id="geburtsdatum" [matDatepicker]="geburtsdatumPicker" [min]="geburtsdatumMinDate" [max]="geburtsdatumMaxDate" placeholder="TT.MM.JJJJ" [formControl]="geburtsdatum">
          <mat-datepicker-toggle matSuffix [for]="geburtsdatumPicker"></mat-datepicker-toggle>
          <mat-datepicker #geburtsdatumPicker></mat-datepicker>
          <mat-error *ngIf="geburtsdatum.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
          <mat-error *ngIf="geburtsdatum.hasError('matDatepickerMin')">{{ 'MINVALUE' | translate:{'value': geburtsdatumMinDate | date} }}</mat-error>
          <mat-error *ngIf="geburtsdatum.hasError('matDatepickerMax')">{{ 'MAXVALUE' | translate:{'value': geburtsdatumMaxDate | date} }}</mat-error>
        </mat-form-field>
        <ng-template [ngTemplateOutlet]="newPasscodeRequestedTemplate"></ng-template>
        <ng-template [ngTemplateOutlet]="attemptErrorsTemplate"></ng-template>
      </div>
    </div>
    <div mat-dialog-actions>
      <button mat-button class="button--primary" (click)="getOffertById$.next()">Absenden</button>
    </div>
  </ng-template>
  <ng-template #firmaDisplay>
    <div mat-dialog-content>
      <p>Bevor Sie aus Ihrem Angebot einen Antrag erstellen können, geben Sie bitte Ihr Passwort ein. Das Passwort wurde bei Erstellung des Angebots im Rechner angezeigt. Falls Sie Ihr Passwort nicht kennen, <a href="javascript:;" (click)="sendPasscodeResetLink$.next()">klicken Sie bitte hier.</a></p>
      <div class="input">
        <app-label [control]="passcode" for="passcode">Passwort:</app-label>
        <mat-form-field>
          <input matInput id="passcode" maxlength="6" [formControl]="passcode">
          <mat-error *ngIf="passcode.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
        </mat-form-field>
        <ng-template [ngTemplateOutlet]="newPasscodeRequestedTemplate"></ng-template>
        <ng-template [ngTemplateOutlet]="attemptErrorsTemplate"></ng-template>
      </div>
    </div>
    <div mat-dialog-actions>
      <button mat-button class="button--primary" (click)="getOffertById$.next()">Absenden</button>
    </div>
  </ng-template>
  <ng-template #validationFailedDisplay>
    <div mat-dialog-content>
      <p class="red-error-text">Aus Datenschutzgründen ist es nicht mehr möglich, mit diesem Link Ihr Angebot aufzurufen. Gerne können Sie im Rechner ein neues Angebot anfordern.</p>
    </div>
    <div mat-dialog-actions>
      <button mat-button class="button--primary" (click)="returnToRechner()">Neues Angebot</button>
    </div>
  </ng-template>
  <ng-template #attemptErrorsTemplate>
    <p *ngIf="attemptCount === 1" class="mt-2 red-error-text">Bitte überprüfen Sie Ihre Eingabe und klicken Sie erneut auf „Absenden“.</p>
    <p *ngIf="attemptCount === 2" class="mt-2 red-error-text">Bitte überprüfen Sie Ihre Eingabe und klicken Sie erneut auf „Absenden“. Beachten Sie, dass dieser Link nach einer weiteren falschen Eingabe ungültig wird.</p>
  </ng-template>
  <ng-template #newPasscodeRequestedTemplate>
    <p *ngIf="passcodeResetResponse$ | async" class="mt-2">In Kürze erhalten Sie ein Bestätigungsmail. Bitte klicken Sie auf den Link darin, um ein neues Passwort zu wählen.</p>
  </ng-template>
</form>
